<template>
  <div>
    <b-modal
      id="modal-detail"
      centered
      size="xl"
      :hide-footer="true"
      ref="modal-detail"
      no-close-on-backdrop
    >
 
     <b-table ref="selectableTable" :items="details" :fields="detail_fields" responsive striped class="my-2">
    <template #cell(actions)="data">
      <b-dropdown variant="link" no-caret :right="$store.state.appConfig.isRTL">

        <template #button-content>
          <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
        </template>



      </b-dropdown>
    </template>
    <template #cell(status_number)="data">
      <b-badge :variant="status[1][data.value]" class="d-block">
        {{ getResultText(data.value) }}
      </b-badge>
    </template>
    <template #cell(amount)="data">
      <span class="font-weight-bolder" v-if="toNumber(data.item.amount) !== null">${{ formatMoney(data.item.amount) }}</span>
    </template>
    <template #cell(member_code)="data">
      <b-badge variant="light-secondary" class="d-block">
        {{data.value }}
      </b-badge>
    </template>
    <template #cell(transaction_code)="data">
      <b-badge variant="light-secondary" class="d-block" v-if="data.value != ''">
        {{data.value }}
      </b-badge>
    </template>
    <template #cell(net)="data">
      <span v-if="toNumber(data.item.amount) !== null && data.item.payment_gateway == 'STRIPE'"><b>${{ formatStripeNet(data.item.amount) }}</b></span>
    </template>
    <template #cell(type_number)="data" >
      <b-badge :variant="status[1][data.value]" class="d-block">
        {{ getResultText(data.value) }}
      </b-badge>
    </template>
  </b-table>
    </b-modal>
        <b-overlay :show="isLoading" rounded opacity="0.6">

    <b-row>
      <b-col cols="12">
      <b-card>
        <b-form-group
          :label="$t('reportOnlinePaymentV2.dateRange')"
          label-for="h-date-range"
        >
      <flat-pickr
          v-model="rangeDate"
          class="form-control mb-1 mr-1"
          :config="{ mode: 'range', dateFormat: 'Y-m-d' }"
        />
      </b-form-group>
      </b-card>
      </b-col>
      <b-col cols="6">
   
    <!-- table -->
        <b-card>
        <h5>{{ $t('reportOnlinePaymentV2.section.settlementList') }}</h5>
    <b-table
      ref="selectableTable"
      selectable
      :select-mode="selectMode"
      :items="items"
      @row-selected="onRowSelected"
      :fields="fields"
      responsive
      striped
      class="mb-0"
    >
     
     <template #cell(settlement_date)="data">
        <b-badge :variant="'light-warning'" v-if="data.item.is_hoilday == 'Y'" class="d-block">
          {{ data.item.settlement_date }} ({{ $t('reportOnlinePaymentV2.holiday') }})
        </b-badge>
        <b-badge :variant="'light-primary'" v-else class="d-block">
            {{ data.item.settlement_date }}
        </b-badge>
      </template>
       <template #cell(net_amount)="data">
        <b-badge :variant="'primary'" v-if="data.item.net_amount > 0"  class="d-block">
          HKD ${{ data.item.net_amount }}
        </b-badge>
      </template>
    </b-table>
  </b-card>
    </b-col>

    <b-col cols="6">
   
    <!-- table -->
        <b-card>
             <h5>{{ $t('reportOnlinePaymentV2.section.payoutList') }}</h5>
    <b-table
      ref="selectableTable"
      :items="payoutitems"
      :fields="payoutfields"
      responsive
      striped
      class="mb-0"
    >

      
       <template #cell(amount)="data">
        <b-badge :variant="'primary'" v-if="data.item.amount > 0" class="d-block">
          HKD ${{ data.item.amount }}
        </b-badge>
      </template>
        <template #cell(status)="data">
        <b-badge :variant="'light-info'" v-if="data.item.status == 'in_transit'" class="d-block">{{ $t('reportOnlinePaymentV2.payoutStatus.in_transit') }}</b-badge>
        <b-badge :variant="'light-success'" v-if="data.item.status == 'paid'"  class="d-block">{{ $t('reportOnlinePaymentV2.payoutStatus.paid') }}</b-badge>
        <b-badge :variant="'danger'" v-if="data.item.status == 'failed'"  class="d-block">{{ $t('reportOnlinePaymentV2.payoutStatus.failed') }}</b-badge>
        <b-badge :variant="'secondary'" v-if="data.item.status == 'canceled'"  class="d-block">{{ $t('reportOnlinePaymentV2.payoutStatus.canceled') }}</b-badge>
      </template>
    </b-table>


  </b-card>
    </b-col>


    </b-row>
    </b-overlay>
  </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'

import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import moment from 'moment'
import {
  BMedia,
  BMediaAside,
  BCardHeader,
  BCardTitle,
  BMediaBody,BCard, BOverlay, BImg , BTable,BTime, BAvatar, BCardBody, BLink,BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BInputGroupPrepend,BModal, VBModal} from 'bootstrap-vue'
export default {
  components: {
    moment,
    BImg,
    BCard,
    BCardHeader,
    BCardTitle,
    flatPickr,
    BTable,
    BModal, VBModal,
    BAvatar,
    BLink,
    BBadge,
    BRow,
    BCol,
    BOverlay,
    BMedia,
  BMediaAside,
  BMediaBody,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BButton,
    BPagination,
    BCardCode,
    BTable,
    BButton,
    BTime,
    BFormGroup,
    BAvatar,
    BCardBody,
    BBadge,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      selected_status : 'ALL',
      rangeDate: null,
      test_string : null,
      user_id : 'all',
      isLoading: false,
      stat : {
        records : 0,
        members : 0
      },
      staffOptions : [],
      target_type:'ALL',
      headerTitle: [],
      headerVal: [],
   
      centerOptions: [],
      salary: 0,
      isAddNewMemberSidebarActive: false,
      stranger : {
        in_time : null
      },
      searchString: null,
      time:{
        from:'00:00',
        to:'23:59'
      },
      stranger_image_src: null,
      perPage: 10,
      startRow: 1,
      endRow: 10,
      pageOptions: [10, 15, 20],
      totalRows: 1,
      currentPage: 1,
      status: [{
          1: 'SUCCESSED',
          2: 'FAILED',
          3: 'MANUAL',
          4: 'AUTO',
          5: 'REFUNDED'
        },
        {
          1: 'light-success',
          2: 'light-danger',
          3: 'primary',
          4: 'warning',
          5: 'secondary'
        }
      ],
      detail_fields: [],
      fields: [],
      details: [],
      payoutfields: [],
        payoutitems: [],
      /* eslint-disable global-require */
      items: [],
      /* eslint-disable global-require */

      selectMode: 'single',
      selected: [],
    }
  },
  watch: {

    rangeDate : {
      handler(newValue, oldValue) {
        const normalizedRange = this.normalizeRangeDate(newValue)
        if (normalizedRange !== newValue) {
          this.rangeDate = normalizedRange
          return
        }
        this.get_data()
        this.get_payout_data()
      },
    },
    '$i18n.locale'() {
      this.detail_fields = this.buildDetailFields()
      this.fields = this.localizeServerFields(this.fields)
      this.payoutfields = this.localizeServerFields(this.payoutfields)
      this.headerTitle = this.headerTitle.map(item => this.translateLabel(item))
    },

    
  },
  created() {
    this.detail_fields = this.buildDetailFields()
    this.get_data()
    this.get_payout_data()
  },
  methods: {
    buildDetailFields() {
      return [
        { key: 'created_at', label: this.$t('reportOnlinePaymentV2.detail.dateTime') },
        { key: 'status_number', label: this.$t('reportOnlinePaymentV2.detail.result') },
        { key: 'amount', label: this.$t('Amount') },
        { key: 'net', label: this.$t('reportOnlinePaymentV2.detail.net') },
        { key: 'type_number', label: this.$t('Type') },
        { key: 'member_code', label: this.$t('Member') },
        { key: 'transaction_code', label: this.$t('reportOnlinePaymentV2.detail.txnCode') },
        { key: 'plan_code', label: this.$t('Plan Code') },
        { key: 'member_code', label: this.$t('Member Code') },
        { key: 'message', label: this.$t('reportOnlinePaymentV2.detail.message') },
      ]
    },
    getResultText(value) {
      const raw = this.status[0][value]
      if (!raw) return ''
      const key = `reportOnlinePaymentV2.result.${raw}`
      return this.$te(key) ? this.$t(key) : raw
    },
    translateLabel(rawLabel) {
      const map = {
        'Transaction Date': 'reportOnlinePaymentV2.table.transactionDate',
        transaction_date: 'reportOnlinePaymentV2.table.transactionDate',
        'Settlement Date': 'reportOnlinePaymentV2.table.settlementDate',
        settlement_date: 'reportOnlinePaymentV2.table.settlementDate',
        'Net Amount': 'reportOnlinePaymentV2.table.netAmount',
        net_amount: 'reportOnlinePaymentV2.table.netAmount',
        'Arrival Date': 'reportOnlinePaymentV2.table.arrivalDate',
        arrival_date: 'reportOnlinePaymentV2.table.arrivalDate',
        amount: 'Amount',
        Amount: 'Amount',
        status: 'Status',
        Status: 'Status',
      }
      const key = map[rawLabel]
      if (key && this.$te(key)) return this.$t(key)
      if (typeof rawLabel === 'string' && this.$te(rawLabel)) return this.$t(rawLabel)
      return rawLabel
    },
    localizeServerFields(serverFields) {
      if (!Array.isArray(serverFields)) return []
      return serverFields.map(field => {
        if (field && typeof field === 'object' && Object.prototype.hasOwnProperty.call(field, 'key')) {
          return {
            ...field,
            label: this.translateLabel(field.label || field.key),
          }
        }

        if (field && typeof field === 'object') {
          const entries = Object.entries(field)
          if (entries.length === 1) {
            const [key, label] = entries[0]
            return {
              key,
              label: this.translateLabel(label || key),
            }
          }
        }

        return field
      })
    },
    normalizeRangeDate(value) {
      if (!value || typeof value !== 'string') return value
      const parts = value.split(' to ')
      if (parts.length < 2 || !parts[0] || !parts[1]) return value

      const start = moment(parts[0], 'YYYY-MM-DD', true)
      const end = moment(parts[1], 'YYYY-MM-DD', true)
      if (!start.isValid() || !end.isValid()) return value

      const maxEnd = start.clone().add(1, 'month')
      if (end.isAfter(maxEnd, 'day')) {
        return `${start.format('YYYY-MM-DD')} to ${maxEnd.format('YYYY-MM-DD')}`
      }
      return value
    },
    toNumber(value) {
      if (value === null || value === undefined || value === '') return null
      const raw = typeof value === 'string' ? value.replace(/,/g, '').trim() : value
      const parsed = Number(raw)
      return Number.isFinite(parsed) ? parsed : null
    },
    formatMoney(value) {
      const amount = this.toNumber(value)
      return amount === null ? '' : amount.toFixed(2)
    },
    formatStripeNet(value) {
      const amount = this.toNumber(value)
      if (amount === null) return ''
      return (amount * 0.966 - 2.35).toFixed(2)
    },
    exportToExcel() {
         import('@/@core/Export2Excel').then(excel => {
           const list = this.items
   
           const data = this.formatJson(this.headerVal, list)
           excel.export_json_to_excel({
             header: this.headerTitle,
             data,
             filename: 'monthly-schedule',
             autoWidth: true,
             bookType: 'xlsx'
           })
           //this.clearFields()
         })
       },
formatJson(filterVal, jsonData) {
  return jsonData.map(row =>
    filterVal.map(key => {
      const value = row[key]
      const type = this.fieldTypes[key]

      if (value === null || value === '') return ''

      switch (type) {
        case 'int':
          return parseInt(value)
        case 'float':
          return parseFloat(value)
        case 'boolean':
          return value ? 'Yes' : 'No'
        case 'date':
          return moment(value).format('YYYY-MM-DD')
        case 'datetime':
          return moment(value).format('YYYY-MM-DD HH:mm')
        default:
          return value
      }
    })
  )
},

 get_payout_data() {
     var splitted = []

  if (this.rangeDate === null) {
        splitted[0] = moment().subtract(7, 'days').format('YYYY-MM-DD')
        splitted[1] = moment().add(11, 'days').format('YYYY-MM-DD')
        this.rangeDate = moment().subtract(7, 'days').format('YYYY-MM-DD') + " to " + moment().add(7, 'days').format('YYYY-MM-DD')
      } else {
        splitted = this.rangeDate.split(" to ");
      }
  this.$http.get(process.env.VUE_APP_API_BASE + `/report/payout/?from=${splitted[0]}&to=${splitted[1]}`)
    .then(res => {
      this.payoutfields = this.localizeServerFields(res.data.fields)
        this.payoutitems = res.data.records
    })
},

 get_data() {
 var splitted = []
      if (this.rangeDate === null) {
        splitted[0] = moment().subtract(7, 'days').format('YYYY-MM-DD')
        splitted[1] = moment().add(11, 'days').format('YYYY-MM-DD')
        this.rangeDate = moment().subtract(7, 'days').format('YYYY-MM-DD') + " to " + moment().add(7, 'days').format('YYYY-MM-DD')
      } else {
        splitted = this.rangeDate.split(" to ");
      }
  this.$http.get(process.env.VUE_APP_API_BASE + `/report/online-payment-v2/?from=${splitted[0]}&to=${splitted[1]}`)
    .then(res => {
      this.fields = this.localizeServerFields(res.data.fields)
      this.items = res.data.records
      this.headerTitle = res.data.excel_fields.map(f => this.translateLabel(f.label))
      this.headerVal = res.data.excel_fields.map(f => f.key)
      this.fieldTypes = res.data.excel_fields.reduce((map, f) => {
        map[f.key] = f.type
        return map
      }, {})
    })
},

    handleChangePage() {

    //  this.get_data()
    },
    onRowSelected(items) {
      if (!Array.isArray(items) || items.length === 0) return
      if (!items[0]) return
      this.isLoading = true
       this.$http.get(process.env.VUE_APP_API_BASE+'/report/online_payment/?transaction_date='+items[0].created_at+'&transfer_id='+items[0].transfer_id)
        .then(res => {
            this.details = res.data
            this.$refs['modal-detail'].show()
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected()
    },
    selectThirdRow() {
      // Rows are indexed from 0, so the third row is index 2
      this.$refs.selectableTable.selectRow(2)
    },
    unselectThirdRow() {
      // Rows are indexed from 0, so the third row is index 2
      this.$refs.selectableTable.unselectRow(2)
    },

    handleSearch() {
      // let _print = `The user searched for: ${searching}\n`
      // this.$refs.pre.appendChild(document.createTextNode(_print))
    // this.searchString = searching
    // this.currentx = 1
    // this.get_data()
      this.searchTimeOut()
    },
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        // your code
        this.currentPage = 1
        this.get_data()
      }, 500)
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
<style lang="scss">
.b-table-selectable{
  .feather{
    font-size: 1.3rem;
  }
}

</style>
